module.exports = __webpack_public_path__ + "img/1506030952.5a89e333.jpg";